import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import VolumesOverlay from "#src/components/VolumesOverlay.vue";
import UserProfile from "#src/components/UserProfile.vue";
import DropdownList from "#src/components/DropdownList.vue";
import { loginSession, useLoginStore } from "#src/store.js";
import logoGemImage from '#src/images/pyr-icon.png';
import logoTextImage from '#src/images/pyr-logo-wordmark.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtensionBar',
  setup(__props, { expose: __expose }) {
  __expose();

const login = useLoginStore();
window.addEventListener("middleauthlogin", () => {
  login.update();
});
login.update();

const validLogins = computed(() =>
  login.sessions.filter((x) => x.status === undefined)
);
const invalidLogins = computed(() =>
  login.sessions.filter((x) => x.status !== undefined)
);

// const { volumes } = useVolumesStore();

onMounted(() => {
  (document.querySelector('.pyr-logo-gem')! as HTMLImageElement).src = logoGemImage;
  (document.querySelector('.pyr-logo-text')! as HTMLImageElement).src = logoTextImage;
  // (document.querySelector('.user-profile-img')! as HTMLImageElement).src = userProfileImage;
});

const showVolumes = ref(false);
const showUserProfile = ref(false);

function logout(session: loginSession) {
  login.logout(session);
}

const __returned__ = { login, validLogins, invalidLogins, showVolumes, showUserProfile, logout, VolumesOverlay, UserProfile, DropdownList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})